import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  Table,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchCategoriesRequest } from "../../store/actions";

// Function to sanitize user input to prevent injection
const sanitizeInput = (input) => {
  return input.replace(/</g, "&lt;").replace(/>/g, "&gt;");
};

const AddCategory = ({ handleAddCategories, handleRemoveCategory }) => {
  const { categories } = useSelector((state) => state.service);
  const [activeTab, setactiveTab] = useState(1);
  const [formData, setFormData] = useState({
    name: "",
    image: null, // Add image field
  });
  const [errors, setErrors] = useState({ name: "", image: "" });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCategoriesRequest());
  }, [dispatch]);

  const validateForm = () => {
    const newErrors = { name: "", image: "" };
    const sanitizedName = sanitizeInput(formData.name);

    if (sanitizedName.trim() === "") {
      newErrors.name = "اسم القسم مطلوب.";
    }

    if (!formData.image) {
      newErrors.image = "الصورة مطلوبة.";
    }

    setErrors(newErrors);

    return Object.values(newErrors).every((error) => error === "");
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();

    if (validateForm()) {
      const sanitizedName = sanitizeInput(formData.name);

      const newData = {
        title: sanitizedName,
        img_file: formData.image, // Pass the image file
      };
      handleAddCategories(newData);

      setFormData({
        name: "",
        image: null,
      });
      setactiveTab(1);
    }
  };

  const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB
  
  const handleImageChange = (event) => {
    const file = event.target.files[0];
  
    if (file) {
      if (file.size > MAX_IMAGE_SIZE) {
        setErrors({
          ...errors,
          image: "حجم الصورة يجب أن لا يتجاوز 2 ميغابايت.",
        });
        setFormData({
          ...formData,
          image: null,
        });
      } else {
        setErrors({
          ...errors,
          image: "",
        });
        setFormData({
          ...formData,
          image: file,
        });
      }
    }
  };

  return (
    <React.Fragment>
      <Container fluid={true}>
        <Row>
          <Col lg="6">
            <Card>
              <CardBody>
                <div className="wizard clearfix">
                  <div className="steps clearfix">
                    <ul>
                      <NavItem
                        className={classnames({ current: activeTab === 1 })}
                      >
                        <NavLink>
                          <span className="number">1</span>
                        </NavLink>
                      </NavItem>
                    </ul>
                  </div>

                  <div className="content clearfix">
                    <TabContent activeTab={activeTab} className="body">
                      <TabPane tabId={1}>
                        <Form>
                         <FormGroup>
                            <Label for="category-name">اسم القسم</Label>
                            <Input
                              type="text"
                              id="category-name"
                              placeholder="أدخل اسم القسم"
                              value={formData.name}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  name: e.target.value,
                                })
                              }
                            />
                            <span className="text-danger">{errors.name}</span>
                          </FormGroup>
                          <FormGroup>
                            <Label for="category-image">صورة القسم</Label>
                            <Input
                              type="file"
                              id="category-image"
                              accept="image/*"
                              onChange={handleImageChange}
                            />
                            <span className="text-danger">{errors.image}</span>
                          </FormGroup>
                        </Form>
                      </TabPane>
                    </TabContent>
                  </div>

                  <div className="actions clearfix">
                    <ul>
                      <li className="next">
                        <Link onClick={handleFormSubmit}>إرسال</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col lg="6" style={{ height: "37vh", overflow: "scroll" }}>
            <Table>
              <thead>
                <tr>
                  <th>الأقسام</th>
                  <th>الصورة</th>
                  <th>الإجراءات</th>
                </tr>
              </thead>
              <tbody>
                {categories.slice().reverse().map((category) => (
                  <tr key={category.id}>
                    <td>{category.title}</td>
                    <td>
                      {category.img_url ? (
                        <img
                          src={category.img_url}
                          alt={category.title}
                          style={{ width: "50px", height: "50px" }}
                        />
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      <Button
                        color="danger"
                        onClick={() => handleRemoveCategory(category)}
                      >
                        حذف
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default AddCategory;